import { render, staticRenderFns } from "./MatterbridgeIntegration.vue?vue&type=template&id=0474f373&scoped=true"
import script from "./MatterbridgeIntegration.vue?vue&type=script&lang=js"
export * from "./MatterbridgeIntegration.vue?vue&type=script&lang=js"
import style0 from "./MatterbridgeIntegration.vue?vue&type=style&index=0&id=0474f373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0474f373",
  null
  
)

export default component.exports